export enum NotificationEventType {
  mentionedInThread = 'mentioned_in_thread',
  newThreadInScope = 'new_thread_in_scope',
  newTaskAssigned = 'new_task_assigned',
  taskCompleted = 'task_completed',
  newPublishedInvoice = 'new_published_invoice',
  newValidatedInvoice = 'new_validated_invoice',
  newCommentInPublicThread = 'new_comment_in_public_thread',
  newCommentInTask = 'new_comment_in_task',
  fileReady = 'file_ready',
  mentionedSummaryReportThread = 'mentioned_summary_report_thread',
}
